<template>
    <div class="approve_admin_approval_settings_wrap">
        <div class="approval_settings_left">
            <ul>
                <li class="ellipsis custom_hover_active_class font_bold " :class="activeGroup == 0 ?  'active' : ''" @click="handleClickGroup({id:0})">
                    <span> 全部({{approvals_count}})</span>
                </li>
                <draggable v-model="settingsList" group="site" @end="handleDraggableGroupEnd">
                    <li  class=" custom_hover_active_class font_bold" :class="activeGroup == item.id ?  'active' : ''" v-for="item in settingsList" @click="handleClickGroup(item)">
                        <span class="ellipsis"> {{item.name}} </span>
                        <span>({{item.approvals.length}})</span>
                    </li>
                </draggable>
            </ul>

        </div>

        <div class="approval_settings_right">
            <div class="approval_settings_top_wrap">
                <div>
                    <el-input size="small" v-model="keywords" placeholder="请输入审批名称"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                        <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                    </el-input>
                </div>
                <div>
                    <el-button @click="handleClickAddGroup" size="small" >新建分组</el-button>
                    <el-button @click="handleClickAddApproval" size="small" type="primary" >创建审批</el-button>
                </div>

            </div>
            <div class="approval_settings_bottom_wrap" ref="approval_settings_bottom_wrap" v-if="settingsList && settingsList.length>0">
                    <div class="approval_settings_group_item" :ref="'approval_settings_group_item_' + item.id" v-for="item in settingsList">
                        <div class="group_item_title">
                            <div class="edit_title_wrap">
                                  <div class="edit_title" v-if="!item.isEdit">
                                      <span  v-text="`${item.name}(${item.approvals.length})`">行政</span>
                                      <span  class="handle_icon_wrap" @click="handleClickEdit(item)">
                                        <i class="iconfont icon-bianji"></i>
                                    </span>
                                  </div>
                                <el-input v-if="item.isEdit" :ref="'editGroupInput'  + item.id" maxlength="20" v-model="item.name" size="small" @keyup.enter.native="handleChangeEnterEditName(item)" @blur="handleChangeEditName($event,item)"></el-input>
                            </div>

                            <span class="handle_icon_wrap handle_icon_danger_wrap" @click="handleClickDelType(item)">
                                <i class="iconfont icon-shanchu1"></i>
                            </span>
                        </div>
                        <div class="group_item_child">
                            <ul>
                                <draggable v-model="item.approvals" group="siteChild" handle=".icon-a-move" @end="handleDraggableEnd">
                                    <template v-if="item.approvals.length>0">
                                        <li v-for="list in item.approvals">
                                        <div class="move_title">
                                            <i class="iconfont icon-a-move"></i>
                                            <img :src="list.icon" alt="">
                                            <span class="ellipsis" v-text="list.name"></span>
                                            <el-tooltip v-if="tooltipText[list.type]"  class="item" effect="dark"  placement="top">
                                                <div class="white_space_pre_wrap" slot="content" v-html="tooltipText[list.type]"></div>
                                                <span class="handle_icon_wrap">
                                                    <i class="iconfont icon-bangzhuzhongxin"></i>
                                                </span>
                                            </el-tooltip>
                                        </div>
                                        <div class="info_text ellipsis">
                                            <span  v-if="list.eligible_users && list.eligible_users.length>0">
                                                <span v-for="(user,userIndex) in list.eligible_users" :key="userIndex" v-text="user.relate_name + ','"></span>
                                            </span>
                                            <span v-else>
                                                <span v-if="list.is_system == 0">全员可见</span>
                                                <span v-if="list.is_system == 1">-</span>
                                            </span>
                                        </div>
                                        <div class="handle_wrap">
                                            <span class="handle_icon_wrap" @click="handleClickEditApproval(list)">
                                                <i class="iconfont icon-bianji"></i>
                                            </span>
                                            <span class="line"  v-if="list.is_system == 0"></span>
                                            <el-tooltip  v-if="list.is_system == 0" class="item" effect="dark" :content="list.status == 1 ? '点击禁用' : '点击启用'" placement="top">
                                               <span class="handle_icon_wrap " :class="list.status == 1 ? 'enable handle_icon_danger_wrap' : 'disable'" @click="handleClickStatus(list)">
                                                    <i class="iconfont icon-a-bingji3"></i>
                                                    <i class="iconfont icon-tingyong"></i>
                                                </span>
                                            </el-tooltip>

                                            <span class="line" v-if="list.is_system == 0"></span>
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"  v-if="list.is_system == 0" @click="handleClickDelApprove(list)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                        </div>
                                    </li>
                                    </template>
                                   <div v-else class="em"><el-empty :image-size="20"></el-empty></div>
                                </draggable>
                            </ul>

                        </div>
                    </div>

            </div>
            <div v-else class="em"><el-empty :image-size="60"></el-empty></div>
        </div>

        <groupingAdd :groupingAddDialog.sync="groupingAddDialog" @success="getApprovalTypeData" v-if="groupingAddDialog"/>
        <formTemplateLibrary :formTemplateLibraryDialog.sync="formTemplateLibraryDialog"   v-if="formTemplateLibraryDialog"/>
    </div>
</template>
<script>
import groupingAdd from "../component/groupingAdd";
import formTemplateLibrary from "../component/formTemplateLibrary"
import { approvalSetList,approvalSetCateDel,approvalSetCateEdit,approvalSetToggleStatus,approvalSetDel,approvalSetCateSort,approvalSetSort } from "@/api/index.js"
import draggable from "vuedraggable";
import {EventBus} from '@/utils/eventBus';
export default {
    name: "ApprovalSettings",
    components: {
        groupingAdd,
        draggable,
        formTemplateLibrary
    },
    data() {
        return {
            keywords:'',
            settingsList:[],
            approvals_count:0,
            groupingAddDialog:false,
            formTemplateLibraryDialog:false,
            activeGroup:0,
            tooltipText:{
                'customer_claim':'1、通过客户公海申领客户时发起\n2、需在此编辑配置审批流程\n3、是否能发起通过客户管理中的权限控制',
                'project_add':'1、通过新建商机提交时发起\n2、需在此编辑配置审批流程\n3、员工是否能够发起通过商机管理中的权限控制',
                'project_edit':'1、通过编辑商机提交时发起\n2、需在此编辑配置审批流程\n3、员工能够新建商机即可编辑商机',
                'quotation_add':'1、通过新建报价单提交时发起\n2、需在此编辑配置审批流程\n3、员工是否能够发起通过商机管理中的权限控制',
                'order_add':'1、通过新建订单提交时发起\n2、需在此编辑配置审批流程\n3、员工是否能够发起通过订单管理中的权限控制',
                'order_purchase':'1、通过订单详情中新增代采明细发起\n2、需在此编辑配置审批流程\n3、员工能够发起订单即可发起代采',
                'order_after_sale':'1、通过订单-发起售后时发起\n2、需在此编辑配置审批流程',
                'workorder_create':'1、通过新建工单提交时发起\n2、需在此编辑配置审批流程\n3、员工是否能够发起通过工单后台设置中的工单角色范围控制',
                'workorder_travel':'1. 通过实施人工单出发时发起\n2. 需在此编辑配置审批流程\n3. 仅简约工程模式存在此审批',
                'workorder_finish':'1. 通过实施人工单结单时发起\n2. 需在此编辑配置审批流程\n3. 仅简约工程模式存在此审批'
            }
        }
    },

    created() {
        this.getApprovalTypeData()
        EventBus.$on('listUpdated', this.getApprovalTypeData);
    },
    methods: {
        // 筛选
        handleClickSearch(){
             this.getApprovalTypeData()
        },
        getApprovalTypeData(){
            approvalSetList({keyword: this.keywords}).then(res=> {
                if(res.code === 200) {
                    this.settingsList = res.data
                    this.activeGroup = 0
                    let approvals_count = 0
                    res.data.forEach(item=>{
                        approvals_count = item.approvals.length + approvals_count
                    })
                    this.approvals_count = approvals_count

                }
            })
        },
        // 切换分类
        handleClickGroup(item){
             this.activeGroup = item.id
             let ref = 'approval_settings_group_item_' + item.id
             if(this.$refs[ref] && this.$refs[ref].length>0){
                const targetElement = this.$refs[ref][0];
                 if (targetElement) {
                  const offset = targetElement.offsetTop - 150
                  this.$refs.approval_settings_bottom_wrap.scrollTo({
                      top: offset,
                      behavior: 'smooth' // 平滑滚动
                  });
                }
             }
        },
        // 新建分组
        handleClickAddGroup(){
            this.groupingAddDialog = true
        },
        // 新建审批
        handleClickAddApproval(){
            this.formTemplateLibraryDialog = true
            // this.$router.push({
            //     name: 'approveAdminSettings',
            // })
        },
        // 新增审批
        handleClickEditApproval(list){
            this.$router.push({
                name: 'approveAdminSettings',
                query:{
                    id:list.id
                }
            })
        },
        handleClickEdit(item){
            this.$set(item,'isEdit',!item.isEdit)
            this.$nextTick(()=>{
                if(this.$refs.editGroupInput && this.$refs.editGroupInput.length){
                    this.$refs.editGroupInput[0].focus()
                }
            })
        },
        handleChangeEnterEditName(item){
            let ref =  'editGroupInput' + item.id
            if(ref){
                this.$refs[ref][0].blur()
            }
        },
        handleChangeEditName(event,item){
            if(!item.name)return   this.$message({type: 'error',message: '请输入分组名称',duration: 1500,})
             approvalSetCateEdit({name:item.name,id:item.id}).then(res=> {
                 if(res.code === 200) {
                    if( this.activeGroup == item.id){
                         this.handleClickGroup({id:0})
                    }
                    this.$message({
                        type: 'success',
                        message: res.message,
                        duration: 1500,
                        onClose: () => {}
                    })
                    this.$set(item,'isEdit',!item.isEdit)
                 }else{
                      this.BtnDisabled = false
                 }
             })
        },
        handleClickDelType(item){
            const h = this.$createElement;
            let isDelete = item.approvals.length > 0 ? true : false
            let title = isDelete ? '需转移当前分组下的审批再删除分组' : '删除该分组后将不复存在'
            this.$msgbox({
                title: '删除分组',
                message: h('div', null, [
                    h('span', null, title),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon ${isDelete ? 'status1' : 'status0'}`,
                customClass: 'prompt_message_custom',
                confirmButtonText:  isDelete ? '知道了' : '删除',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: !isDelete,
                confirmButtonClass: !isDelete ? 'el-button--danger danger' : 'el-button--primary',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                if(isDelete){return false}
                approvalSetCateDel({id:item.id}).then(res=> {
                 if(res.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '您已删除该分组',
                        duration: 1500,
                        onClose: () => {}
                    })
                     this.getApprovalTypeData()
                 }
              })
            }).catch(() => {

            })
        },
        // 启用禁用
        handleClickStatus(list){
            approvalSetToggleStatus({id:list.id,status:list.status == 1 ? 0 : 1}).then(res=> {
                if(res.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '操作成功',
                        duration: 1500,
                        onClose: () => {}
                    })
                    this.getApprovalTypeData()
                }
            })
        },
        handleClickDelApprove(list){
            const h = this.$createElement;
            this.$msgbox({
                title: '删除',
                message: h('div', null, [
                    h('span', null, `您确定删除该审批单吗？`),
                ]),
                iconClass: 'icon-jinggao iconfont prompt_message_icon status0',
                customClass: 'prompt_message_custom',
                confirmButtonText: '删除',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: 'danger' ,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                approvalSetDel({id:list.id}).then(res=> {
                    if(res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '您已删除该审批',
                            duration: 1500,
                            onClose: () => {}
                        })
                        this.getApprovalTypeData()
                    }
                })
            }).catch(() => {

            })
        },

        handleDraggableGroupEnd(){
            let data = this.settingsList.map((item,index)=>{
                return {
                    id:item.id,
                    sort:this.settingsList.length - index
                }
            })
            approvalSetCateSort({sort_data:data}).then(res=>{
                if(res.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '操作成功',
                        duration: 1500,
                        onClose: () => {}
                    })
                }
            })
        },
        handleDraggableEnd(){
            let data = []
            let number = 0
            this.settingsList.forEach((item,index)=>{
                number = number + item.approvals.length
            })
            this.settingsList.forEach((item,index)=>{
               item.approvals.forEach((list,childIndex)=>{
                   data.push({
                       category_id:item.id,
                       id:list.id,
                       sort:number--
                   })
                })

            })
            approvalSetSort({sort_data:data}).then(res=>{
                if(res.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '操作成功',
                        duration: 1500,
                        onClose: () => {}
                    })
                }
            })
        },

    },
    beforeDestroy() {
        EventBus.$off('listUpdated', this.getApprovalTypeData);
    },
}
</script>
<style lang="scss" scoped>
@import "@/styles/approval.scss";
</style>
